import "cross-fetch/polyfill"
import {
  ApolloClient,
  from,
  ApolloLink,
  InMemoryCache,
  HttpLink
} from "@apollo/client"
import { onError } from "@apollo/client/link/error"

const httpLink = new HttpLink({
  uri: `${document.body.dataset.apiRoot}/graphql`
})

const errorLink = onError(({ graphQLErrors, networkError }) => {
  // below used for error logging, can used for debugging or logging to 3rd party service
  // eslint-disable-next-line no-undef
  if (process.env.NODE_ENV) {
    if (graphQLErrors)
      graphQLErrors.map(({ message, locations, path }) =>
        console.log(
          `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
        )
      )
    if (networkError) console.log(`[Network error]: ${networkError}`)
  }
})

// the auth token is sent to the server on each request due to this middleware
const authMiddleware = new ApolloLink((operation, forward) => {
  operation.setContext(({ headers = {} }) => ({
    headers: {
      ...headers,
      "X-CSRF-Token": document
        .querySelector('meta[name="csrf-token"]')
        .getAttribute("content")
    }
  }))

  return forward(operation)
})

const appCache = new InMemoryCache()

const client = new ApolloClient({
  link: from([authMiddleware, errorLink, httpLink]),
  cache: appCache,
  credentials: "include"
})

export default client
